module.exports = __webpack_public_path__ + "static/media/music-icon.d8a90778.svg";